import { useSelector } from 'react-redux';

const useRecordBeingViewed = (id) => {
  const user = useSelector((state) => state.user);
  const userId = (user || {}).id;

  const recordsSet = useSelector((state) => state.ui.viewingRecord);
  const record = (recordsSet || []).find((n) => n.id === id);
  const recordUserId = (record || {}).userId;
  if (record && recordUserId && userId !== recordUserId) {
    return true;
  }
  return false;
};

export { useRecordBeingViewed };
